export default "__VITE_ASSET__C48DJjRl__"